import { FC } from 'react';
import { Divider, VStack } from '@chakra-ui/react';

import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';

import type { DetailedTransaction } from '../../../../hooks/useDetailedTransactionQuery';
import {
  InvoiceAttachmentCard,
  ReceiptAttachmentCard,
} from './components/AttachmentCard';
import LegacyAttachment from './components/LegacyAttachment';

interface AttachmentsProps {
  invoiceId: string | null;
  transactionId: string;
  transactionType: DetailedTransaction['type'];
  transactionTotal: number;
  receipts: NonNullable<DetailedTransaction['receipts']>;
  singleReceipt: DetailedTransaction['receipt'];
}

const Attachments: FC<AttachmentsProps> = ({
  invoiceId,
  receipts,
  singleReceipt,
  transactionId,
  transactionTotal,
  transactionType,
}) => {
  const { featureFlags } = useFeatureFlagsSwitcher();

  /**
   * @todo Remove feature flag and components after multi-doc release
   * @link https://linear.app/shine/issue/CAC-58
   */
  if (!featureFlags.enableMultipleTransactionDocs) {
    return (
      <LegacyAttachment
        invoiceId={invoiceId}
        receipt={singleReceipt}
        transactionId={transactionId}
        transactionType={transactionType}
      />
    );
  }

  return (
    <VStack align="unset" divider={<Divider />} spacing="space-16">
      {invoiceId ? (
        <InvoiceAttachmentCard
          invoiceId={invoiceId}
          transactionId={transactionId}
          transactionType={transactionType}
        />
      ) : null}

      {receipts.map((receipt) => (
        <ReceiptAttachmentCard
          key={receipt?.receiptId}
          receipt={receipt}
          transactionId={transactionId}
          transactionTotal={transactionTotal}
          transactionType={transactionType}
        />
      ))}
    </VStack>
  );
};

export default Attachments;
